import { render } from "./Footer-component.vue?vue&type=template&id=1da5cac3&scoped=true"
import script from "./Footer-component.vue?vue&type=script&lang=js"
export * from "./Footer-component.vue?vue&type=script&lang=js"

import "./Footer-component.vue?vue&type=style&index=0&id=1da5cac3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da5cac3"]])

export default __exports__